import {RestResource} from '../rest'

import { ASSET_SERVER } from '../server'
import {athubAxios} from "@/util";

const locations = new RestResource({server: ASSET_SERVER, resource: 'locations'});

locations.getLocationsByIds = (ids) => {
    return new Promise((resolve, reject) => {
        if (ids == null || ids.length === 0) {
            resolve([]);
        } else {
            athubAxios.post(`${ASSET_SERVER}/locations/list/ids`, ids).then((response) => {
                if (response.status === 200) {
                    resolve(response.data.data);
                } else {
                    reject(response.data.message);
                }
            }).catch(error => {
                reject(error);
            });
        }

    });
};

export default locations;
